<!-- <div class="collection-collapse-block" [class.open]="collapse" *ngIf="filterbyBrand.length">
    <h3 class="collapse-block-title" (click)="collapse = !collapse">brand</h3>
    <div class="collection-collapse-block-content">
        <div class="collection-brand-filter">
            <div class="custom-control custom-checkbox collection-filter-checkbox" *ngFor="let brand of filterbyBrand; let i = index">
                <input type="checkbox" [value]="brand" [checked]="checked(brand)" [id]="brand" (change)="appliedFilter($event)" class="custom-control-input" />
                <label class="custom-control-label" for="{{ brand }}">{{ brand }}</label>
            </div>
        </div>
    </div>
</div> -->

<!-- <div class="collection-collapse-block" [class.open]="collapse" *ngIf="filterbyBrand.length">
    <h3 class="collapse-block-title" (click)="collapse = !collapse">Brand</h3>
    <div class="collection-collapse-block-content">
        <div class="collection-brand-filter">
            <div class="custom-control custom-checkbox collection-filter-checkbox" *ngFor="let sub of subCategoryCollection; let i = index">
                <input type="checkbox" [value]="sub.subCategoryId" [checked]="false" [id]="sub.subCategoryId" (change)="appliedFilter($event)" class="custom-control-input" />
                <label class="custom-control-label" for="{{ sub.subCategoryId }}">{{ sub.subCategoryName }}</label>
            </div>
        </div>
    </div>
</div> -->


<div class="collection-collapse-block border-0" [class.open]="collapse">
    <h3 class="collapse-block-title" (click)="collapse = !collapse">{{'SUBCATEGORIES'|translate}}</h3>
    <div class="collection-collapse-block-content">
        <div class="collection-brand-filter">
            <ul class="category-list">
                <li *ngFor="let sub of subCategoryCollection">

                    <!-- <a [routerLink]="['/shop/collection/left/sidebar']" [queryParams]="{ category: category}">
                        {{ category.categoryId }} {{ category.categoryName }}
                    </a> -->
                    <a type="button" (click)="OnFilterSubCategory(sub.subCategoryId,sub.mainSubCategoryName)">
                        {{ sub.subCategoryName }} 
 
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>